<template>
  <v-select
      v-model="item"
      dir="rtl"
      :clearable="clearable"
      :multiple="multiple"
      label="Title"
      :reduce="x => x.Id"
      :options="items"
      :selectable="x => unselectable.includes(x.Id) === false || x === val"
      :loading="loading"
      :filter="filterTree"
      @open="onOpen"
  >
    <span
        slot="no-options"
        @click="$refs.select.open = false"
    >
      موردی یافت نشد
    </span>

    <!-- نمایش درختی گزینه‌ها در لیست باز‌شده -->
    <template #option="{ Title, depth, hasChildren }">
      <div
          class="z-tree-option"
          :style="{ paddingRight: `${depth * 18}px` }"
      >
        <span
            v-for="n in depth"
            :key="n"
            class="z-tree-guide"
        />
        <span :class="{ 'font-weight-bold': hasChildren }">{{ Title }}</span>
      </div>
    </template>

    <!-- نمایش آیتم انتخاب‌شده بدون تورفتگی -->
    <template #selected-option="{ Title }">
      {{ Title }}
    </template>

    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
            v-if="loading"
            class="m-0"
            small
            variant="secondary"
        />
      </div>
    </template>
  </v-select>
</template>

<script>

export default {
  name: 'ZCircularDocumentType',
  props: {
    value: {
      type: Number,
      default: null,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    unselectable: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      items: [],
      val: this.value,
      loading: false,
    }
  },
  computed: {
    item: {
      get() {
        if (this.value) {
          this.get()
        }
        return this.val
      },
      set(newValue) {
        this.$emit('input', newValue)
        this.val = newValue
      },
    },
  },
  watch: {
    value(v) {
      this.val = v
    },
  },
  methods: {
    get() {
      if (this.items.length === 0) {
        this.loading = true
        this.$http.post(
            this.$api.circulardocumenttype.getall, {},
        )
            .then(res => {
              this.items = this.buildTree(res.data)
              this.loading = false
            })
      }
    },
    buildTree(list) {
      // گروه‌بندی بچه‌ها بر اساس آیدی والد
      const childrenOf = {}
      list.forEach(item => {
        const parentId = item.CircularDocumentTypeId || 0
        if (!childrenOf[parentId]) childrenOf[parentId] = []
        childrenOf[parentId].push(item)
      })

      // مرتب‌سازی هر گروه بر اساس فیلد ترتیب (Sort) و سپس آیدی
      Object.values(childrenOf).forEach(arr => arr.sort((a, b) => (a.Sort ?? 0) - (b.Sort ?? 0) || a.Id - b.Id))

      // مرتب‌سازی تخت ولی به ترتیب درختی (والد → بچه → نوه ...) با هر عمقی
      const result = []
      const walk = (parentId, depth) => {
        const children = childrenOf[parentId] || []
        children.forEach(item => {
          result.push({
            ...item,
            depth,
            hasChildren: (childrenOf[item.Id] || []).length > 0,
          })
          walk(item.Id, depth + 1)
        })
      }
      walk(0, 0)
      return result
    },
    // فیلتر سفارشی: آیتم‌های منطبق + والدهاشون نمایش داده می‌شن تا درخت حفظ بمونه
    filterTree(options, search) {
      const q = search.trim().toLowerCase()
      if (!q) return options

      const byId = {}
      options.forEach(o => { byId[o.Id] = o })

      const keep = new Set()
      options.forEach(o => {
        if ((o.Title || '').toLowerCase().includes(q)) {
          keep.add(o.Id)
          // افزودن کل زنجیره‌ی والدها تا ریشه
          let parentId = o.CircularDocumentTypeId
          while (parentId && byId[parentId]) {
            keep.add(parentId)
            parentId = byId[parentId].CircularDocumentTypeId
          }
        }
      })

      // ترتیب درختی اصلی حفظ می‌شه
      return options.filter(o => keep.has(o.Id))
    },
    onOpen() {
      this.get()
    },
  },
}
</script>

<style lang="scss" scoped>
.z-tree-option {
  display: flex;
  align-items: center;
}

.z-tree-branch {
  margin-left: 15px;
  flex-shrink: 0;
}
</style>
